<div
  class="flex-left-column light-control-host"
  arpSurfaceErrorHost="edit-integration-dialog"
  #dialogError="surfaceErrorHost"
>
  <div class="modal-header">
    <h3 class="panel-title">
      @if (!!integration) {
        Update Add On
      } @else {
        Configure New Add On
      }
    </h3>
    <button
      type="button"
      class="modal-close-btn"
      (click)="onCancelClick()"
      pTooltip="Close"
      tooltipPosition="left"
      aria-label="Close"
    >
      <svg lucideX></svg>
    </button>
  </div>
  <form class="full-width" [formGroup]="integrationSettingsFormModel" (ngSubmit)="onSaveClick()">
    <div class="flex-center-row margin-top full-width">
      <h4>Add on type:</h4>
      @if (!integration) {
        <div class="select-wrapper flex-center-row spacer">
          <select class="arpio-select margin-left spacer" formControlName="integrationType">
            <option></option>
            @for (i of entitledIntegrations; track i) {
              <option [value]="i.integrationType">
                {{ i.displayString }}
              </option>
            }
          </select>
        </div>
      } @else {
        <div class="margin-left">{{ integration.config.getTypeDisplayString() }}</div>
        <input
          id="integration-type"
          type="hidden"
          [value]="integration.config.getIntegrationType()"
          formControlName="integrationType"
        />
      }
    </div>
    <div>
      <h4 class="margin-top half-margin-bottom">Description:</h4>
      <div class="flex-center-row full-width">
        <input
          id="application-notification-emails-input"
          class="arpio-input spacer"
          type="text"
          formControlName="integrationName"
          placeholder="Briefly describe this instance of this add on"
        />
      </div>
    </div>
    <div>
      @switch (integrationSettingsFormModel.value.integrationType) {
        @case ('spotByNetApp') {
          <spot-by-netapp-settings formControlName="integrationConfig"></spot-by-netapp-settings>
        }
      }
    </div>

    @if (dialogError.error) {
      <arp-error-block
        class="dialog-error"
        [error]="dialogError.error"
        [dismissible]="true"
        (dismissed)="dialogError.clear()"
      ></arp-error-block>
    }

    <div class="modal-footer">
      @if (dialogError.error?.blockedReason) {
        <span class="modal-footer-hint">{{ dialogError.error.blockedReason }}</span>
      }
      <button class="arpio-secondary-button" (click)="onCancelClick()" [disabled]="saving" type="button">Cancel</button>
      <button
        busy-button
        [busy]="saving"
        id="conclude-button"
        class="arpio-button"
        type="submit"
        [disabled]="saving || !valid || !!dialogError.error?.blockedReason"
      >
        Save
      </button>
    </div>
  </form>
</div>
